module.exports = __webpack_public_path__ + "fonts/RenaultLife-Light.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Light.svg
// module id = 362
// module chunks = 0